import { useGameSelector } from '../../../store/GameStore';
import { airplaneStates } from './types';

export const useAirPlaneSlice = {
  getcurrentState: (): airplaneStates => {
    return useGameSelector(({ highflyerAirPlane }) => highflyerAirPlane.currentState);
  },
  isAnimating: (): boolean => {
    return useGameSelector(({ highflyerAirPlane }) => highflyerAirPlane.isAnimating);
  },
};
